<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess">
    <z-page :title="title">
          <w-card
      title-class="blue-gradient--bg white"
      style="font-size: 14px;"
      class="pa0"
    >

      <template #title>
        <div class="grow uppercase font-weight-bold">MAKLUMAT TERNAKAN</div>
        <w-button lg color="white" @click="showMaklumat = !showMaklumat" class="ml-auto">
          <w-icon>{{ showMaklumat ? 'fal fa-angle-double-up' : 'fal fa-angle-double-down' }}</w-icon>
        </w-button>
      </template>


      <div v-show="showMaklumat">


        <div class="w-flex justify-center wrap px4 pt4" v-if="form.atthectment_image && form.atthectment_image.length > 0">
          <div class="gallery-item ma2" v-for="(image, index) in form.atthectment_image" :key="index">
            <div class="image-wrapper" style="cursor: pointer;">
              <img
                :src="image.url"
                :alt="image.name"
                @click="openZoomModal(image.url)"
                class="gallery-image uniform-image"
              >
            </div>
            <div class="image-actions text-center mt1">
              <a :href="image.url" target="_blank" class="mr2">
                <w-icon xs>fal fa-search-plus</w-icon>
              </a>
            </div>
          </div>
        </div>


        <w-modal v-if="zoomModalVisible" @close="zoomModalVisible = false">
          <div class="zoom-modal-content">
            <img :src="zoomedImageUrl" class="full-zoom-image uniform-zoom-image">
            <w-button
              class="close-zoom-btn"
              @click="zoomModalVisible = false"
              bg-color="error"
            >
              <w-icon>fal fa-times</w-icon>
            </w-button>
          </div>
        </w-modal>


        <div class="w-card__content pa4">
          <div class="ternakan-info">
            <div class="ternakan-info__grid">
              <div class="ternakan-field">
                <div class="ternakan-field__label"><b>No Pendaftaran</b></div>
                <div class="ternakan-field__colon"><b>:</b></div>
                <div class="ternakan-field__value blue-dark3--text">
                  {{ (form && form.ternakan && form.ternakan.kode) || '-' }}
                </div>
              </div>

              <div class="ternakan-field">
                <div class="ternakan-field__label"><b>Jenis Ternakan</b></div>
                <div class="ternakan-field__colon"><b>:</b></div>
                <div class="ternakan-field__value blue-dark3--text">
                  {{ (form && form.ternakan && form.ternakan.lkp_ternakan && form.ternakan.lkp_ternakan.nama) || '-' }}
                </div>
              </div>

              <div class="ternakan-field">
                <div class="ternakan-field__label"><b>Jantina</b></div>
                <div class="ternakan-field__colon"><b>:</b></div>
                <div class="ternakan-field__value blue-dark3--text">
                  {{ form && form.ternakan && form.ternakan.jantina == 1 ? 'Jantan' : form && form.ternakan && form.ternakan.jantina == 2 ? 'Betina' : '-' }}
                </div>
              </div>

              <div class="ternakan-field">
                <div class="ternakan-field__label"><b>ID / Nama Ternakan</b></div>
                <div class="ternakan-field__colon"><b>:</b></div>
                <div class="ternakan-field__value blue-dark3--text">
                  {{ (form && form.ternakan && form.ternakan.id_ternakan) || '-' }} /
                  {{ (form && form.ternakan && form.ternakan.nama) || '-' }}
                </div>
              </div>

              <div class="ternakan-field">
                <div class="ternakan-field__label"><b>Baka</b></div>
                <div class="ternakan-field__colon"><b>:</b></div>
                <div class="ternakan-field__value blue-dark3--text">
                  {{ (form && form.ternakan && form.ternakan.lkp_baka && form.ternakan.lkp_baka.nama) || '-' }}
                </div>
              </div>

              <div class="ternakan-field">
                <div class="ternakan-field__label"><b>Tarikh Lahir</b></div>
                <div class="ternakan-field__colon"><b>:</b></div>
                <div class="ternakan-field__value blue-dark3--text">
                  {{ $zutil.dateformat(form && form.ternakan && form.ternakan.tarikh_lahir) || '-' }}
                </div>
              </div>

              
              <div class="ternakan-field">
                <div class="ternakan-field__label"><b>Warna</b></div>
                <div class="ternakan-field__colon"><b>:</b></div>
                <div class="ternakan-field__value blue-dark3--text">
                  {{
                    (form && form.ternakan && form.ternakan.lkp_warna && form.ternakan.lkp_warna.nama)
                    || (form && form.lkp_warna)
                    || (form && form.ternakan && form.ternakan.warna)
                    || '-'
                  }}
                </div>
              </div>

              
              <div class="ternakan-field">
                <div class="ternakan-field__label"><b>Negara Asal</b></div>
                <div class="ternakan-field__colon"><b>:</b></div>
                <div class="ternakan-field__value blue-dark3--text">
                  {{
                    (form && form.ternakan && form.ternakan.negara_asal && form.ternakan.negara_asal.nama)
                    || (form && form.negara_asal)
                    || '-'
                  }}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </w-card>


<template v-if="form.art.lkp_tujuan_id == 10">
      <w-card
  title-class="blue-gradient--bg white"
  style="font-size: 14px;"
>
  <!-- Header seragam dengan tombol LG -->
  <template #title>
    <div class="grow uppercase">CIRI CIRI BAKA</div>
    <w-button
      lg
      color="white"
      @click="showCiriBaka = !showCiriBaka"
      class="ml-auto"
    >
      <w-icon class="mr1">
        {{ showCiriBaka ? 'fal fa-angle-double-up' : 'fal fa-angle-double-down' }}
      </w-icon>
    </w-button>
  </template>

  <!-- Konten yang di-toggle -->
  <div v-show="showCiriBaka">
    <div class="w-card__content content-hardcode">
      <div class="genital-exam-container">
        <span class="input-hint">** Adakah ciri-ciri baka berkaitan dengan ternakan ini?</span>
        &nbsp;
        <div class="exam-grid">

          <!-- Warna Bulu -->
          <div class="exam-item">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon> Warna Bulu
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  Warna Bulu
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="form.warna_bulu"
              :items="baka_list"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />
            <w-input
              v-if="form.warna_bulu == 1"
              class="abnormal-input"
              label="Sila Nyatakan *"
              type="text"
              v-model="form.warna_bulu_nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>

          <!-- Saiz Kepala -->
          <div class="exam-item">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon> Saiz Kepala
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  Saiz Kepala
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="form.saiz_kepala"
              :items="baka_list"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />
            <w-input
              v-if="form.saiz_kepala == 1"
              class="abnormal-input"
              label="Sila Nyatakan *"
              type="text"
              v-model="form.saiz_kepala_nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>

          <!-- Dahi -->
          <div class="exam-item">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon> Dahi
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  Dahi
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="form.dahi"
              :items="baka_list"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />
            <w-input
              v-if="form.dahi == 1"
              class="abnormal-input"
              label="Sila Nyatakan *"
              type="text"
              v-model="form.dahi_nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>

          <!-- Tanduk -->
          <div class="exam-item">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon> Tanduk
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  Tanduk
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="form.tanduk"
              :items="baka_list"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />
            <w-input
              v-if="form.tanduk == 1"
              class="abnormal-input"
              label="Sila Nyatakan *"
              type="text"
              v-model="form.tanduk_nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>

          <!-- Telinga (Margin sudah diperbaiki) -->
          <div class="exam-item">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon> Telinga
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  Telinga
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="form.telinga"
              :items="baka_list"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />
            <w-input
              v-if="form.telinga == 1"
              class="abnormal-input"
              label="Sila Nyatakan *"
              type="text"
              v-model="form.telinga_nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>

          <!-- Bonggol -->
          <div class="exam-item">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon> Bonggol
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  Bonggol
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="form.bonggol"
              :items="baka_list"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />
            <w-input
              v-if="form.bonggol == 1"
              class="abnormal-input"
              label="Sila Nyatakan *"
              type="text"
              v-model="form.bonggol_nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>

          <!-- Ciri - Ciri Unik -->
          <div class="exam-item">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon> Ciri - Ciri Unik
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  Ciri - Ciri Unik
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="form.ciri"
              :items="baka_list"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />
            <w-input
              v-if="form.ciri == 1"
              class="abnormal-input"
              label="Sila Nyatakan *"
              type="text"
              v-model="form.ciri_nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</w-card>


</template>
     <w-card
  title-class="blue-gradient--bg white"
  style="font-size: 14px;"
>
  <!-- Header seragam dengan card lainnya -->
  <template #title>
    <div class="grow uppercase">PEMERIKSAAN FIZIKAL</div>
    <w-button
      lg
      color="white"
      @click="showFizikal = !showFizikal"
      class="ml-auto"
    >
      <w-icon class="mr1">
        {{ showFizikal ? 'fal fa-angle-double-up' : 'fal fa-angle-double-down' }}
      </w-icon>
    </w-button>
  </template>

  <!-- Konten yang di-toggle -->
  <div v-show="showFizikal">
    <div class="w-card__content content-hardcode">
      <div class="genital-exam-container">
        <div class="exam-grid">

          <!-- Skor Badan (BCS) -->
          <div class="exam-item" v-if="getInfoByKode('pf.bcs')">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon>
                {{ getInfoByKode('pf.bcs').nama }}
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  {{ getInfoByKode('pf.bcs').keterangan }}
                </w-tooltip>
              </h3>
            </div>
            <z-select
              :items="skorbadanlist"
              :disabled="form.hantar == 1"
              v-model="form.skor"
              :validators="[validators.required]"
              outlined
            />
          </div>

          <!-- Berat Badan -->
          <div class="exam-item" v-if="getInfoByKode('pf.b')">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon>
                {{ getInfoByKode('pf.b').nama }}
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  {{ getInfoByKode('pf.b').keterangan }}
                </w-tooltip>
              </h3>
            </div>
            <w-input
              class="abnormal-input"
              type="number"
              v-model="form.berat"
              :disabled="form.hantar==1"
              label="Berat Badan (kg)"
              :validators="[validators.required]"
              outlined
            />
          </div>

          <!-- Tanda Klinikan -->
          <div class="exam-item" v-if="getInfoByKode('pf.tkp')">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon>
                {{ getInfoByKode('pf.tkp').nama }}
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  {{ getInfoByKode('pf.tkp').keterangan }}
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="form.tanda_klinikan"
              :items="tanda_list"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />
            <w-input
              v-if="form.tanda_klinikan == 1"
              class="abnormal-input"
              label="Jika YA, sila nyatakan *"
              type="text"
              v-model="form.tanda_klinikan_nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>

          <!-- Sub Header: Musculoskeletal -->
          <div class="section-header full-width">
            <h3 class="section-title"><i class="fal fa-bone"></i> Pemeriksaan Musculoskeletal</h3>
          </div>

          <!-- Otot -->
          <div class="exam-item" v-if="getInfoByKode('pm.l')">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon>
                <i>{{ getInfoByKode('pm.l').nama }}</i>
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  {{ getInfoByKode('pm.l').keterangan }}
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="form.otot"
              :items="vulva_list"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />
            <w-input
              v-if="form.otot == 2"
              class="abnormal-input"
              label="Jika ABNORMAL, sila nyatakan *"
              type="text"
              v-model="form.otot_nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>

          <!-- Sendi -->
          <div class="exam-item" v-if="getInfoByKode('pm.pk')">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon>
                {{ getInfoByKode('pm.pk').nama }}
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  {{ getInfoByKode('pm.pk').keterangan }}
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="form.sendi"
              :items="vulva_list"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />
            <w-input
              v-if="form.sendi == 2"
              class="abnormal-input"
              label="Jika ABNORMAL, sila nyatakan *"
              type="text"
              v-model="form.sendi_nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>

          <!-- Postur -->
          <div class="exam-item" v-if="getInfoByKode('pm.pb')">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon>
                {{ getInfoByKode('pm.pb').nama }}
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  {{ getInfoByKode('pm.pb').keterangan }}
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="form.postur"
              :items="vulva_list"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />
            <w-input
              v-if="form.postur == 2"
              class="abnormal-input"
              label="Jika ABNORMAL, sila nyatakan *"
              type="text"
              v-model="form.postur_nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>

          <!-- Skor Libido -->
          <div class="exam-item" v-if="getInfoByKode('pm.pl')">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon>
                {{ getInfoByKode('pm.pl').nama }}
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  {{ getInfoByKode('pm.pl').keterangan }}
                </w-tooltip>
              </h3>
            </div>
            <w-input
              label="Sila Masukkan Nilai (0-10)"
              type="number"
              v-model.number="form.skor_libido"
              :disabled="form.hantar == 1"
              :validators="[skorLibidoValidator]"
              min="0"
              max="10"
              outlined
            />
          </div>


        <div class="section-header full-width">
  <h3 class="section-title"><i class="fal fa-bone"></i> Analisa Kualiti Semen Dan Spermatozoa</h3>
  <div class="dropdown-container" style="margin-left: 20px; display: inline-block;">
    <z-select
      :items="spermatozoa"
      :disabled="form.hantar == 1"
      label="Sila Pilih Dulu"
      v-model="form.spermatozoa_uji"
      :validators="[validators.required]"
      outlined
      style="width: 150px;"
    />
   </div>
   &nbsp; &nbsp;
    <w-input
      v-if="form.spermatozoa_uji == 2"
      style="width: 150px;"
      outline
      label="Catatan *"
      v-model="form.catatan_uji"
      :validators="[validators.required]"
    />
</div>

<!-- Perubahan: Ubah kondisi dari form.spermatozoa_uji == 2 menjadi form.spermatozoa_uji == 1 -->
<template v-if="form.spermatozoa_uji == 1">
        <div class="exam-item" v-if="getInfoByKode('ak.kps')">
           <div class="exam-header">
             <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon>
               {{ getInfoByKode('ak.kps').nama }}
               <w-tooltip position="right">
                 <template #activator="{ on }">
                   <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                 </template>
                 {{ getInfoByKode('ak.kps').keterangan }}
               </w-tooltip>
             </h3>
           </div>
          <z-select
            :items="pungutan_list"
            :disabled="form.hantar == 1"
            v-model="form.pungutan"
            :validators="[validators.required]"
            outlined
          />
        </div>

        <div class="exam-item" v-if="getInfoByKode('ak.i')">
           <div class="exam-header">
             <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon>
               {{ getInfoByKode('ak.i').nama }}
               <w-tooltip position="right">
                 <template #activator="{ on }">
                   <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                 </template>
                 {{ getInfoByKode('ak.i').keterangan }}
               </w-tooltip>
             </h3>
           </div>
           <w-input
            class="abnormal-input"
            label="Isipadu (ml)"
            type="text"
            v-model="form.isipadu"
            :disabled="form.hantar == 1"
            :validators="[validators.required]"
            outlined
          />
        </div>

        <div class="exam-item" v-if="getInfoByKode('ak.w')">
           <div class="exam-header">
             <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon>
               {{ getInfoByKode('ak.w').nama }}
               <w-tooltip position="right">
                 <template #activator="{ on }">
                   <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                 </template>
                 {{ getInfoByKode('ak.w').keterangan }}
               </w-tooltip>
             </h3>
           </div>
          <w-input
            class="abnormal-input"
            type="text"
            v-model="form.warna"
            :disabled="form.hantar==1"
            label="Warna"
            :validators="[validators.required]"
            outlined
          />
        </div>

       <div class="exam-item" v-if="getInfoByKode('ak.ke')">
           <div class="exam-header">
             <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon>
               {{ getInfoByKode('ak.ke').nama }}
               <w-tooltip position="right">
                 <template #activator="{ on }">
                   <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                 </template>
                 {{ getInfoByKode('ak.ke').keterangan }}
               </w-tooltip>
             </h3>
           </div>
           <w-input
            class="abnormal-input"
            label="Kepekatan"
            type="text"
            v-model="form.kepekatan"
            :disabled="form.hantar == 1"
            :validators="[validators.required]"
            outlined
          />
        </div>

        <div class="exam-item" v-if="getInfoByKode('ak.sm')">
           <div class="exam-header">
             <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon>
               {{ getInfoByKode('ak.sm').nama }}
               <w-tooltip position="right">
                 <template #activator="{ on }">
                   <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                 </template>
                 {{ getInfoByKode('ak.sm').keterangan }}
               </w-tooltip>
             </h3>
           </div>
          <!-- <z-select
            :items="motilitilist"
            :disabled="form.hantar == 1"
            v-model="form.motiliti"
            :validators="[validators.required]"
            outlined
          /> -->
          <w-input
              label="Sila Masukkan Nilai (0-5)"
              type="number"
              v-model.number="form.motiliti"
              :disabled="form.hantar == 1"
              :validators="[motilitiValidator]"
              min="0"
              max="5"
              outlined
            />

        </div>

        <div class="exam-item" v-if="getInfoByKode('ak.mh')">
           <div class="exam-header">
             <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon>
               {{ getInfoByKode('ak.mh').nama }}
               <w-tooltip position="right">
                 <template #activator="{ on }">
                   <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                 </template>
                 {{ getInfoByKode('ak.mh').keterangan }}
               </w-tooltip>
             </h3>
           </div>
           <w-input
            class="abnormal-input"
            label="% Motiliti Hidup"
            type="text"
            v-model="form.motiliti_hidup"
            :disabled="form.hantar == 1"
            :validators="[validators.required]"
            outlined
          />
        </div>

         <div class="exam-item" v-if="getInfoByKode('ak.mp')">
           <div class="exam-header">
             <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon>
               {{ getInfoByKode('ak.mp').nama }}
               <w-tooltip position="right">
                 <template #activator="{ on }">
                   <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                 </template>
                 {{ getInfoByKode('ak.mp').keterangan }}
               </w-tooltip>
             </h3>
           </div>
           <w-input
            class="abnormal-input"
            label="% Motiliti Progresif"
            type="text"
            v-model="form.motiliti_progresif"
            :disabled="form.hantar == 1"
            :validators="[validators.required]"
            outlined
          />
        </div>


        <div class="exam-item" v-if="getInfoByKode('ak.k')">
           <div class="exam-header">
             <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon>
               {{ getInfoByKode('ak.k').nama }}
               <w-tooltip position="right">
                 <template #activator="{ on }">
                   <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                 </template>
                 {{ getInfoByKode('ak.k').keterangan }}
               </w-tooltip>
             </h3>
           </div>
          <w-radios
            v-model="form.kecacatan"
            :items="tanda_list"
            inline
            :disabled="form.hantar == 1"
            :validators="[validators.required]"
            color="blue-dark3"
          />
          <w-input
            v-if="form.kecacatan == 1"
            class="abnormal-input"
            label="Jika YA, sila nyatakan *"
            type="text"
            v-model="form.kecacatan_nyatakan"
            :disabled="form.hantar == 1"
            :validators="[validators.required]"
            outlined
          />
        </div>

     </template>


       </div>
      </div>
    </div>
  </div>
</w-card>
<w-card
  title-class="blue-gradient--bg white"
  style="font-size: 14px;"
>
  <!-- Header Seragam -->
  <template #title>
    <div class="grow uppercase">PEMERIKSAAN ORGAN GENITAL LUARAN</div>
    <w-button
      lg
      color="white"
      @click="showGenitalLuaran = !showGenitalLuaran"
      class="ml-auto"
    >
      <w-icon class="mr1">
        {{ showGenitalLuaran ? 'fal fa-angle-double-up' : 'fal fa-angle-double-down' }}
      </w-icon>
    </w-button>
  </template>

  <!-- Konten yang di-toggle -->
  <div v-show="showGenitalLuaran">
    <div class="w-card__content content-hardcode">
      <div class="genital-exam-container">
        <div class="exam-grid">

          <!-- Testis -->
          <div class="exam-item" v-if="getInfoByKode('po.t')">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon>
                <i>{{ getInfoByKode('po.t').nama }}</i>
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  {{ getInfoByKode('po.t').keterangan }}
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="form.testis"
              :items="vulva_list"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />
            <w-input
              v-if="form.testis == 2"
              class="abnormal-input"
              label="Jika ABNORMAL, sila nyatakan *"
              type="text"
              v-model="form.testis_nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>

          <!-- Epididymis -->
          <div class="exam-item" v-if="getInfoByKode('po.e')">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon>
                <i>{{ getInfoByKode('po.e').nama }}</i>
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  {{ getInfoByKode('po.e').keterangan }}
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="form.epididymis"
              :items="vulva_list"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />
            <w-input
              v-if="form.epididymis == 2"
              class="abnormal-input"
              label="Jika ABNORMAL, sila nyatakan *"
              type="text"
              v-model="form.epididymis_nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>

          <!-- Korda Spermatik -->
          <div class="exam-item" v-if="getInfoByKode('po.ks')">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon>
                <i>{{ getInfoByKode('po.ks').nama }}</i>
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  {{ getInfoByKode('po.ks').keterangan }}
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="form.korda"
              :items="vulva_list"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />
            <w-input
              v-if="form.korda == 2"
              class="abnormal-input"
              label="Jika ABNORMAL, sila nyatakan *"
              type="text"
              v-model="form.korda_nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>

          <!-- Penis -->
          <div class="exam-item" v-if="getInfoByKode('po.p')">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon>
                <i>{{ getInfoByKode('po.p').nama }}</i>
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  {{ getInfoByKode('po.p').keterangan }}
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="form.penis"
              :items="vulva_list"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />
            <w-input
              v-if="form.penis == 2"
              class="abnormal-input"
              label="Jika ABNORMAL, sila nyatakan *"
              type="text"
              v-model="form.penis_nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>

          <!-- Skor Kekenyalan Testis -->
          <div class="exam-item" v-if="getInfoByKode('po.skt')">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon>
                <i>{{ getInfoByKode('po.skt').nama }}</i>
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  {{ getInfoByKode('po.skt').keterangan }}
                </w-tooltip>
              </h3>
            </div>
            <w-input
              label="Sila Masukkan Nilai (0-4)"
              type="number"
              v-model.number="form.kekenyalan_testis"
              :disabled="form.hantar == 1"
              :validators="[kekenyalanTestisValidator]"
              min="0"
              max="4"
              outlined
            />
          </div>

        </div> <!-- End exam-grid -->
      </div> <!-- End genital-exam-container -->
    </div> <!-- End w-card__content -->
  </div> <!-- End v-show -->
</w-card>

<w-card
  title-class="blue-gradient--bg white"
  style="font-size: 14px;"
>
  <template #title>
    <div class="grow uppercase">UKURLILIT SKROTUM CM</div>
    <w-button
      lg
      color="white"
      @click="showSkrotum = !showSkrotum"
      class="ml-auto"
    >
      <w-icon class="mr1">
        {{ showSkrotum ? 'fal fa-angle-double-up' : 'fal fa-angle-double-down' }}
      </w-icon>
    </w-button>
  </template>
  <div v-show="showSkrotum">
    <div class="w-card__content content-hardcode">
      <div class="genital-exam-container">
        <div class="exam-grid">

          <div class="exam-item" v-if="getInfoByKode('us')">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon>
                <i>{{ getInfoByKode('us').nama }}</i>
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  {{ getInfoByKode('us').keterangan }}
                </w-tooltip>
              </h3>
            </div>

            <w-input
              class="abnormal-input"
              label="Ukurlilit Skrotum CM"
              type="number"
              v-model="form.skortum"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>

        </div>
      </div>
    </div>
  </div>
</w-card>
<w-card
  title-class="blue-gradient--bg white"
  style="font-size: 14px;"
>
  <!-- Header Seragam dengan tombol LG -->
  <template #title>
    <div class="grow uppercase">PEMERIKSAAN ORGAN GENITAL DALAMAN</div>
    <w-button
      lg
      color="white"
      @click="showGenitalDalaman = !showGenitalDalaman"
      class="ml-auto"
    >
      <w-icon class="mr1">
        {{ showGenitalDalaman ? 'fal fa-angle-double-up' : 'fal fa-angle-double-down' }}
      </w-icon>
    </w-button>
  </template>

  <!-- Konten yang di-toggle -->
  <div v-show="showGenitalDalaman">
    <div class="w-card__content content-hardcode">
      <div class="genital-exam-container">
        <div class="exam-grid">

          <!-- Ampullae -->
          <div class="exam-item" v-if="getInfoByKode('pogd.a')">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon>
                <i>{{ getInfoByKode('pogd.a').nama }}</i>
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  {{ getInfoByKode('pogd.a').keterangan }}
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="form.ampullae"
              :items="vulva_list"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />
            <w-input
              v-if="form.ampullae == 2"
              class="abnormal-input"
              label="Jika ABNORMAL, sila nyatakan *"
              type="text"
              v-model="form.ampullae_nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>

          <!-- Kelenjar Vesikal -->
          <div class="exam-item" v-if="getInfoByKode('pogd.kv')">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon>
                <i>{{ getInfoByKode('pogd.kv').nama }}</i>
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  {{ getInfoByKode('pogd.kv').keterangan }}
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="form.vesikal"
              :items="vulva_list"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />
            <w-input
              v-if="form.vesikal == 2"
              class="abnormal-input"
              label="Jika ABNORMAL, sila nyatakan *"
              type="text"
              v-model="form.vesikal_nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>

          <!-- Kelenjar Prostat -->
          <div class="exam-item" v-if="getInfoByKode('pogd.kp')">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon>
                <i>{{ getInfoByKode('pogd.kp').nama }}</i>
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  {{ getInfoByKode('pogd.kp').keterangan }}
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="form.prostat"
              :items="vulva_list"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />
            <w-input
              v-if="form.prostat == 2"
              class="abnormal-input"
              label="Jika ABNORMAL, sila nyatakan *"
              type="text"
              v-model="form.prostat_nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>

        </div> <!-- End exam-grid -->
      </div> <!-- End genital-exam-container -->
    </div> <!-- End w-card__content -->
  </div> <!-- End v-show -->
</w-card>


<w-card
  title-class="blue-gradient--bg white"
  style="font-size: 14px;"
>
  <!-- Header Seragam -->
  <template #title>
    <div class="grow uppercase">SIFAT TERNAKAN</div>
    <w-button
      lg
      color="white"
      @click="showSifat = !showSifat"
      class="ml-auto"
    >
      <w-icon class="mr1">
        {{ showSifat ? 'fal fa-angle-double-up' : 'fal fa-angle-double-down' }}
      </w-icon>
    </w-button>
  </template>

  <!-- Konten yang di-toggle -->
  <div v-show="showSifat">
    <div class="w-card__content content-hardcode">
      <div class="genital-exam-container">
        <div class="exam-grid">
          <div class="exam-item" v-if="getInfoByKode('st')">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon>
                {{ getInfoByKode('st').nama }}
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  {{ getInfoByKode('st').keterangan }}
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="form.temprament"
              :items="temprament_list"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</w-card>

<w-card
  title-class="blue-gradient--bg white"
  style="font-size: 14px;"
>
  <!-- Header Seragam -->
  <template #title>
    <div class="grow uppercase">STATUS PEMERIKSAAN PENYAKIT (DOKUMEN)</div>
    <w-button
      lg
      color="white"
      @click="showPenyakit = !showPenyakit"
      class="ml-auto"
    >
      <w-icon class="mr1">
        {{ showPenyakit ? 'fal fa-angle-double-up' : 'fal fa-angle-double-down' }}
      </w-icon>
    </w-button>
  </template>

  <!-- Konten yang di-toggle -->
  <div v-show="showPenyakit">
    <div class="w-card__content content-hardcode">
      <div class="genital-exam-container">
        <div class="exam-grid">
          <div class="exam-item mb4" v-for="(dt, ind) in form.lkp_penyakit_bse" :key="dt.id">
            <div class="exam-header mb2">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon> {{ dt.label }}
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  {{ dt.label }}
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="dt.status"
              :items="kasihatan_list"
              inline
              :disabled="form.hantar == 1"
              color="blue-dark3"
              :validators="[validators.required]"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</w-card>



<w-card
  title-class="blue-gradient--bg white"
  style="font-size: 14px;"
>
  <!-- Header Seragam -->
  <template #title>
    <div class="grow uppercase">STATUS PEMERIKSAAN PENYAKIT (FIZIKAL)</div>
    <w-button
      lg
      color="white"
      @click="showPenyakitFizikal = !showPenyakitFizikal"
      class="ml-auto"
    >
      <w-icon class="mr1">
        {{ showPenyakitFizikal ? 'fal fa-angle-double-up' : 'fal fa-angle-double-down' }}
      </w-icon>
    </w-button>
  </template>

  <!-- Konten yang di-toggle -->
  <div v-show="showPenyakitFizikal">
    <div class="w-card__content content-hardcode">
      <div class="genital-exam-container">
        <div class="exam-grid">
          <div class="exam-item mb4" v-for="(dt, ind) in form.lkp_penyakit_fizikal_bse" :key="dt.id">
            <div class="exam-header mb2">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon> {{ dt.label }}
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  Pemeriksaan untuk {{ dt.label }}
                </w-tooltip>
              </h3>
            </div>
            <w-radios
              v-model="dt.status"
              :items="kasihatan_fizikal_list"
              inline
              :disabled="form.hantar == 1"
              color="blue-dark3"
              :validators="[validators.required]"
            />
            <w-input
              v-if="dt.status == 1"
              class="abnormal-input"
              label="Jika ADA, sila nyatakan *"
              type="text"
              v-model="dt.nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</w-card>


<w-card
  title-class="blue-gradient--bg white"
  style="font-size: 14px;"
>
  <!-- Header Seragam -->
  <template #title>
    <div class="grow uppercase">STATUS PEMERIKSAAN</div>
    <w-button
      lg
      color="white"
      @click="showStatusAkhir = !showStatusAkhir"
      class="ml-auto"
    >
      <w-icon class="mr1">
        {{ showStatusAkhir ? 'fal fa-angle-double-up' : 'fal fa-angle-double-down' }}
      </w-icon>
    </w-button>
  </template>

  <!-- Konten yang di-toggle -->
  <div v-show="showStatusAkhir">
    <div class="w-card__content content-hardcode">
      <div class="genital-exam-container">
        <div class="exam-grid">
          <div class="exam-item" v-if="getInfoByKode('sp')">
            <div class="exam-header">
              <h3 class="exam-title">
                <w-icon class="fal fa-circle exam-icon"></w-icon>
                {{ getInfoByKode('sp').nama }}
                <w-tooltip position="right">
                  <template #activator="{ on }">
                    <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                  </template>
                  {{ getInfoByKode('sp').keterangan }}
                </w-tooltip>
              </h3>
            </div>

            <w-radios
              v-model="form.lkp_status_id"
              :items="lkp_status"
              inline
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              color="blue-dark3"
            />

            <w-input
              v-if="form.lkp_status_id == 38"
              class="abnormal-input"
              label="Jika LULUS BERSYARAT, sila nyatakan *"
              type="text"
              v-model="form.status_nyatakan"
              :disabled="form.hantar == 1"
              :validators="[validators.required]"
              outlined
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</w-card>

<!-- <w-card
  title-class="blue-gradient--bg white"
  style="font-size: 14px;"
  :title="'CATATAN'"
>
  <div class="w-card__content content-hardcode">
    <div class="genital-exam-container">
      <div class="exam-grid">
        <div class="exam-item">
          <div class="exam-header">
            <h3 class="exam-title">
               <w-icon class="fal fa-circle exam-icon"></w-icon> Catatan
                    <w-tooltip position="right">
                      <template #activator="{ on }">
                        <w-icon v-on="on" class="fal fa-info-circle info-icon"></w-icon>
                      </template>
                      Catatan
                    </w-tooltip>
                  </h3>
               </div>
          <w-input
            class="abnormal-input"
            type="text"
            v-model="form.ulasan"
            :disabled="form.hantar==1"
            label="Catatan"
            :validators="[validators.required]"
            outlined
          />
        </div>
      </div>
    </div>
  </div>
</w-card> -->
      <w-flex class="mt3" wrap align-center justify-end v-if="$zutil.anyRole(['4']) && form.hantar!=1">
        <w-button class="my1" :loading="form.submitted && !form.sent" @click="saveForm()">
          <w-icon dark tile class="mr2">fal fa-save</w-icon> SIMPAN
        </w-button>
        &nbsp;
        <w-button class="my1" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="submitForm()">
          <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
        </w-button>
      </w-flex>
      <div class="mt2 text-left">
        <w-button style="
                  background-color: #f0f0f0;
                  border: 2px solid red;
                  color: #333;
                  padding: 7px 14px;
                  font-size: 10px;
                  font-weight: bold;
                  border-radius: 4px;
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
      </div>
  </z-page>
    </w-form>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    id: [Array, Object],
    d_form: [Array, Object],
    d_lkp_negeri: [Array, Object],


  },
  data() {
    return {
      resourceurl: 'art.semakan.penilaian',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Penilaian Daya Biak (BSE)', route: '/pdbf' },
        { label: 'Penilaian', route: '/pdbf/penilaian' },
      ],
      negeri : '',
      title : 'PDBF  Penilaian',
      form : this.d_form,

      lkp_status : [],
      info_pdbf : [],
      lkp_penyakit_bse : [],
      showMaklumat: true,
      showCiriBaka: true,
      showFizikal: true,
      showGenitalLuaran: true,
      showSkrotum: true,
      showGenitalDalaman: true,
      showSifat: true,
      showPenyakit: true,
      zoomModalVisible: false,
      zoomedImageUrl: '',
      showPenyakitFizikal: true,
      showStatusAkhir: true,
      validators: {
      required: (value) => !!value || 'Pastikan data sudah di pilih'
    },
      skorbadanlist:[
        {value: 1, label: "1"},
        {value: 2, label: "2"},
        {value: 3, label: "3"},
        {value: 4, label: "4"},
        {value: 5, label: "5"}
      ],
      testislist:[
        {value: 1, label: "0"},
        {value: 2, label: "1"},
        {value: 3, label: "2"},
        {value: 4, label: "3"},
        {value: 5, label: "4"}
      ],
      skorlibidolist:[
        {value: 1, label: "0"},
        {value: 2, label: "1"},
        {value: 3, label: "2"},
        {value: 4, label: "3"},
        {value: 5, label: "4"},
        {value: 6, label: "5"},
        {value: 7, label: "6"},
        {value: 8, label: "7"},
        {value: 9, label: "8"},
        {value: 10, label: "9"},
        {value: 11, label: "10"}
      ],
      skrotumlist:[
        {value: 1, label: "1"},
        {value: 2, label: "2"},
        {value: 3, label: "3"},
        {value: 4, label: "4"},
        {value: 5, label: "5"}
      ],
      pungutan_list:[
        {value: 1, label: "Palpasi Rektal"},
        {value: 2, label: "Elektroejakulasi"},
        {value: 3, label: "Vaginal Tiruan"}
      ],
      warna_list:[
        {value: 1, label: "Biru"},
        {value: 2, label: "Merah"},
      ],
      spermatozoa:[
        {value: 1, label: "Di Uji"},
        {value: 2, label: "Tidak Di Uji"},
      ],
      motilitilist:[
        {value: 1, label: "0"},
        {value: 2, label: "1"},
        {value: 3, label: "2"},
        {value: 4, label: "3"},
        {value: 5, label: "4"},
        {value: 6, label: "5"}
      ],
      vulva_list:[
        {value: 1, label: "Normal"},
        {value: 2, label: "Abnormal"},
      ],
      kasihatan_list:[
        {value: 1, label: "Positif"},
        {value: 2, label: "Negatif"},
        {value: 3, label: "Belum di Uji"},

      ],
      kasihatan_fizikal_list:[
        {value: 1, label: "Ada"},
        {value: 2, label: "Tidak Ada Klinikal"},

      ],
      baka_list:[
        {value: 1, label: "Ya"},
        {value: 2, label: "Tidak"},
        {value: 3, label: "Tidak Berkenaan"},

      ],
      tanda_list:[
        {value: 1, label: "Ya"},
        {value: 2, label: "Tidak"},
      ],
      lokasi_list:[
        {value: 1, label: "Pelvic"},
        {value: 2, label: "Abdomen"},
      ],
      bentuk_list:[
        {value: 1, label: "Lurus"},
        {value: 2, label: "Bengkok"},
      ],
      temprament_list:[
        {value: 1, label: "Jinak"},
        {value: 2, label: "Agresif"},
      ],
      status_list:[
        {value: 1, label: "Lulus"},
        {value: 2, label: "Gagal"},
        {value: 3, label: "Lulus Bersyarat"},

      ],
      loading : 0,
      checkin:false,

    }
  },
  methods: {
    send(hantar){
      this.form.hantar = hantar
      // this.form.lkp_penyakit_bse = this.form.lkp_penyakit_bse
      this.onSuccess()
    },

     onValidate(hantar) {

     if (!this.validateForm()) {
       this.form.sent = false;
       return;
     }


     this.form.hantar = hantar;
     this.form.sent = false;
     this.onSuccess();
   },


   submitForm() {

     if (!this.validateForm()) {
       return;
     }


     this.send(1);
   },

   saveForm() {

     if (!this.validateForm()) {
       return;
     }


     this.send(2);
   },

  skorLibidoValidator(value) {

    if (value === null || value === undefined || value === '') {
      return 'Sila masukkan nilai (0–10)'
    }

    if (value < 0 || value > 10) {
      return 'Nilai mesti antara 0 hingga 10'
    }

    return true
  },

  kekenyalanTestisValidator(value) {
    if (value === null || value === undefined || value === '') {
      return 'Sila masukkan nilai (0–4)'
    }

    if (value < 0 || value > 4) {
      return 'Nilai mesti antara 0 hingga 4'
    }

    return true
  },

  motilitiValidator(value) {
    if (value === null || value === undefined || value === '') {
      return 'Sila masukkan nilai Motiliti (0–5)'
    }

    if (value < 0 || value > 5) {
      return 'Motiliti mesti antara 0 hingga 5'
    }

    return true
  },

  openZoomModal(imageUrl) {
    this.zoomedImageUrl = imageUrl;
    this.zoomModalVisible = true;
  },

  validateForm() {
  if (this.form.art.lkp_tujuan_id == 10) {
    if (!this.form.warna_bulu) {
      this.$zutil.notify("Sila pilih status Warna Bulu.", false);
      this.form.valid = true;
      return false;
    }
    if (this.form.warna_bulu == 1 && !this.form.warna_bulu_nyatakan) {
      this.$zutil.notify("Sila nyatakan Warna Bulu.", false);
      this.form.valid = true;
      return false;
    }

    if (!this.form.saiz_kepala) {
      this.$zutil.notify("Sila pilih status Saiz Kepala.", false);
      this.form.valid = true;
      return false;
    }
    if (this.form.saiz_kepala == 1 && !this.form.saiz_kepala_nyatakan) {
      this.$zutil.notify("Sila nyatakan Saiz Kepala.", false);
      this.form.valid = true;
      return false;
    }

    if (!this.form.dahi) {
      this.$zutil.notify("Sila pilih status Dahi.", false);
      this.form.valid = true;
      return false;
    }
    if (this.form.dahi == 1 && !this.form.dahi_nyatakan) {
      this.$zutil.notify("Sila nyatakan Dahi.", false);
      this.form.valid = true;
      return false;
    }

    if (!this.form.tanduk) {
      this.$zutil.notify("Sila pilih status Tanduk.", false);
      this.form.valid = true;
      return false;
    }
    if (this.form.tanduk == 1 && !this.form.tanduk_nyatakan) {
      this.$zutil.notify("Sila nyatakan Tanduk.", false);
      this.form.valid = true;
      return false;
    }

    if (!this.form.telinga) {
      this.$zutil.notify("Sila pilih status Telinga.", false);
      this.form.valid = true;
      return false;
    }
    if (this.form.telinga == 1 && !this.form.telinga_nyatakan) {
      this.$zutil.notify("Sila nyatakan Telinga.", false);
      this.form.valid = true;
      return false;
    }

    if (!this.form.bonggol) {
      this.$zutil.notify("Sila pilih status Bonggol.", false);
      this.form.valid = true;
      return false;
    }
    if (this.form.bonggol == 1 && !this.form.bonggol_nyatakan) {
      this.$zutil.notify("Sila nyatakan Bonggol.", false);
      this.form.valid = true;
      return false;
    }

    if (!this.form.ciri) {
      this.$zutil.notify("Sila pilih status Ciri-Ciri Unik.", false);
      this.form.valid = true;
      return false;
    }
    if (this.form.ciri == 1 && !this.form.ciri_nyatakan) {
      this.$zutil.notify("Sila nyatakan Ciri-Ciri Unik.", false);
      this.form.valid = true;
      return false;
    }
  }

  if (!this.form.skor) {
    this.$zutil.notify("Sila isi Skor Badan.", false);
    this.form.valid = true;
    return false;
  }
  if (!this.form.berat) {
    this.$zutil.notify("Sila isi Berat Badan.", false);
    this.form.valid = true;
    return false;
  }
  if (isNaN(this.form.berat)) {
    this.$zutil.notify("Berat Badan perlu dalam format nombor.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.tanda_klinikan === null || this.form.tanda_klinikan === undefined) {
    this.$zutil.notify("Sila pilih Tanda Klinikal Penyakit.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.tanda_klinikan == 1 && !this.form.tanda_klinikan_nyatakan) {
    this.$zutil.notify("Sila nyatakan Tanda Klinikal Penyakit.", false);
    this.form.valid = true;
    return false;
  }

  if (this.form.otot === null || this.form.otot === undefined) {
    this.$zutil.notify("Sila pilih Locomotor.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.otot == 2 && !this.form.otot_nyatakan) {
    this.$zutil.notify("Sila nyatakan Locomotor yang abnormal.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.sendi === null || this.form.sendi === undefined) {
    this.$zutil.notify("Sila pilih Postur Kaki.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.sendi == 2 && !this.form.sendi_nyatakan) {
    this.$zutil.notify("Sila nyatakan Postur Kaki yang abnormal.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.postur === null || this.form.postur === undefined) {
    this.$zutil.notify("Sila pilih Postur Badan.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.postur == 2 && !this.form.postur_nyatakan) {
    this.$zutil.notify("Sila nyatakan Postur Badan yang abnormal.", false);
    this.form.valid = true;
    return false;
  }
  // if (
  // this.form.skor_libido === null ||
  // this.form.skor_libido === undefined ||
  // this.form.skor_libido === ''
  //  ) {
  //    this.$zutil.notify("Sila pilih Skor Libido.", false);
  //    this.form.valid = false;
  //    return false;
  //  }

  if (!this.form.spermatozoa_uji) {
    this.$zutil.notify("Sila pilih status ujian spermatozoa.", false);
    this.form.valid = true;
    return false;
  }

  if (this.form.spermatozoa_uji == 1) {
    if (!this.form.pungutan) {
      this.$zutil.notify("Sila pilih Kaedah Pungutan Semen.", false);
      this.form.valid = true;
      return false;
    }
    if (!this.form.isipadu) {
      this.$zutil.notify("Sila isi Isipadu.", false);
      this.form.valid = true;
      return false;
    }
    if (isNaN(this.form.isipadu)) {
      this.$zutil.notify("Isipadu perlu dalam format nombor.", false);
      this.form.valid = true;
      return false;
    }
    if (!this.form.warna) {
      this.$zutil.notify("Sila pilih Warna.", false);
      this.form.valid = true;
      return false;
    }
    if (!this.form.kepekatan) {
      this.$zutil.notify("Sila isi Kepekatan.", false);
      this.form.valid = true;
      return false;
    }
    // if (!this.form.motiliti) {
    //   this.$zutil.notify("Sila pilih Motiliti.", false);
    //   this.form.valid = true;
    //   return false;
    // }
    if (!this.form.motiliti_hidup) {
      this.$zutil.notify("Sila isi Motiliti Hidup.", false);
      this.form.valid = true;
      return false;
    }
    if (isNaN(this.form.motiliti_hidup)) {
      this.$zutil.notify("Motiliti Hidup perlu dalam format nombor.", false);
      this.form.valid = true;
      return false;
    }
    if (!this.form.motiliti_progresif) {
      this.$zutil.notify("Sila isi Motiliti Progresif.", false);
      this.form.valid = true;
      return false;
    }
    if (isNaN(this.form.motiliti_progresif)) {
      this.$zutil.notify("Motiliti Progresif perlu dalam format nombor.", false);
      this.form.valid = true;
      return false;
    }
    if (this.form.kecacatan === null || this.form.kecacatan === undefined) {
      this.$zutil.notify("Sila pilih Kecacatan.", false);
      this.form.valid = true;
      return false;
    }
    if (this.form.kecacatan == 1 && !this.form.kecacatan_nyatakan) {
      this.$zutil.notify("Sila nyatakan Kecacatan.", false);
      this.form.valid = true;
      return false;
    }
  }

  if (this.form.spermatozoa_uji == 2) {
    if (!this.form.catatan_uji) {
      this.$zutil.notify("Sila isi catatan untuk spermatozoa yang tidak diuji.", false);
      this.form.valid = true;
      return false;
    }
  }

  if (this.form.testis === null || this.form.testis === undefined) {
    this.$zutil.notify("Sila pilih Testis.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.testis == 2 && !this.form.testis_nyatakan) {
    this.$zutil.notify("Sila nyatakan Testis yang abnormal.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.epididymis === null || this.form.epididymis === undefined) {
    this.$zutil.notify("Sila pilih Epididymis.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.epididymis == 2 && !this.form.epididymis_nyatakan) {
    this.$zutil.notify("Sila nyatakan Epididymis yang abnormal.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.korda === null || this.form.korda === undefined) {
    this.$zutil.notify("Sila pilih Korda Spermatik.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.korda == 2 && !this.form.korda_nyatakan) {
    this.$zutil.notify("Sila nyatakan Korda Spermatik yang abnormal.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.penis === null || this.form.penis === undefined) {
    this.$zutil.notify("Sila pilih Prepuce/Penis.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.penis == 2 && !this.form.penis_nyatakan) {
    this.$zutil.notify("Sila nyatakan Prepuce/Penis yang abnormal.", false);
    this.form.valid = true;
    return false;
  }
  // if (this.form.kekenyalan_testis === null || this.form.kekenyalan_testis === '' || this.form.kekenyalan_testis === undefined) {
  // this.$zutil.notify("Sila pilih Skor Kekenyalan Testis.", false);
  // this.form.valid = true;
  // return false;
  //  }

  //  if (this.form.kekenyalan_testis < 0 || this.form.kekenyalan_testis > 4) {
  //    this.$zutil.notify("Sila masukkan nilai antara 0 hingga 4.", false);
  //    this.form.valid = true;
  //    return false;
  //  }
  if (!this.form.skortum) {
    this.$zutil.notify("Sila pilih Ukurlilit Skrotum.", false);
    this.form.valid = true;
    return false;
  }
  if (isNaN(this.form.skortum)) {
    this.$zutil.notify("Ukurlilit Skrotum perlu dalam format nombor.", false);
    this.form.valid = true;
    return false;
  }

  if (this.form.ampullae === null || this.form.ampullae === undefined) {
    this.$zutil.notify("Sila pilih Ampullae.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.ampullae == 2 && !this.form.ampullae_nyatakan) {
    this.$zutil.notify("Sila nyatakan Ampullae yang abnormal.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.vesikal === null || this.form.vesikal === undefined) {
    this.$zutil.notify("Sila pilih Kelenjar Vesikal.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.vesikal == 2 && !this.form.vesikal_nyatakan) {
    this.$zutil.notify("Sila nyatakan Kelenjar Vesikal yang abnormal.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.prostat === null || this.form.prostat === undefined) {
    this.$zutil.notify("Sila pilih Kelenjar Prostat.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.prostat == 2 && !this.form.prostat_nyatakan) {
    this.$zutil.notify("Sila nyatakan Kelenjar Prostat yang abnormal.", false);
    this.form.valid = true;
    return false;
  }

  if (this.form.temprament === null || this.form.temprament === undefined) {
    this.$zutil.notify("Sila pilih Sifat Ternakan.", false);
    this.form.valid = true;
    return false;
  }

  if (this.form.lkp_penyakit_bse) {
    for (let i = 0; i < this.form.lkp_penyakit_bse.length; i++) {
      if (!this.form.lkp_penyakit_bse[i].status) {
        this.$zutil.notify(`Sila pilih status untuk ${this.form.lkp_penyakit_bse[i].label}.`, false);
        this.form.valid = true;
        return false;
      }
    }
  }

  if (this.form.lkp_penyakit_fizikal_bse) {
    for (let i = 0; i < this.form.lkp_penyakit_fizikal_bse.length; i++) {
      if (!this.form.lkp_penyakit_fizikal_bse[i].status) {
        this.$zutil.notify(`Sila pilih status untuk ${this.form.lkp_penyakit_fizikal_bse[i].label}.`, false);
        this.form.valid = true;
        return false;
      }
      if (this.form.lkp_penyakit_fizikal_bse[i].status == 1 && !this.form.lkp_penyakit_fizikal_bse[i].nyatakan) {
        this.$zutil.notify(`Sila nyatakan untuk ${this.form.lkp_penyakit_fizikal_bse[i].label}.`, false);
        this.form.valid = true;
        return false;
      }
    }
  }

  if (this.form.lkp_status_id === null || this.form.lkp_status_id === undefined) {
    this.$zutil.notify("Sila pilih Status Pemeriksaan.", false);
    this.form.valid = true;
    return false;
  }
  if (this.form.lkp_status_id == 38 && !this.form.status_nyatakan) {
    this.$zutil.notify("Sila nyatakan Status Pemeriksaan yang bersyarat.", false);
    this.form.valid = true;
    return false;
  }

  return true;
},

    onSuccess(){
      if(this.form.hantar == 1){
        this.$swal({
            title: 'Anda Pasti?',
            // text: "Are you sure want to delete this item!",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya',
            cancelButtonText: 'Tidak'
          }).then((result) => {
            if (result.value) {
              if (this.form.id > 0){
                this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
                .then(res => {
                  if (typeof this.onAfterEdit === "function") {
                    this.onAfterEdit()
                  }
                  if (this.form.hantar==1) {
                      // this.$inertia.visit(this.$route('art.semakan.penilaian.index', this.form.id));
                      this.$inertia.visit(this.$route('art.semakan.bse', this.form.art_id));
                  }else{
                      this.$zutil.notify("Berjaya disimpan", true);
                  }
                  // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
                })
              }
            }
          })
      }else{
        if (this.form.id > 0)
        {

          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            if (this.form.hantar==1) {
                this.$inertia.visit(this.$route('art.semakan.penilaian.index'));
            }else{
                this.$zutil.notify("Berjaya disimpan", true);
                this.$inertia.visit(this.$route('art.semakan.penilaian.form', this.form.id));
            }
            // this.$inertia.visit(this.$route('se.pemungutan.show', this.form.id))
          })
        }

      }

    },

    getPenyakitBse() {
     this.$zcomm.get(this.api_service + 'lookup/lkp_penyakit_bse', {})
       .then(res => {
         this.lkp_penyakit_bse = res;


         this.lkp_penyakit_bse.forEach(p => {
           if (!this.dt.status[p.id]) {
             this.$set(this.dt.status, p.id, null);
           }
         });
       });
   },

    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_lgb', {}).then(res => {
        this.lkp_status = res
      })
    },

    getInfoPdbf() {
      this.$zcomm.get(this.api_service + 'lookup/info_pdbf', {}).then(res => {
        this.info_pdbf = res;
      });
    },
   getInfoByKode(kode) {
      return this.info_pdbf.find(x => x.kode === kode) || { nama: '', keterangan: '' };
   },



     tutup(){
        // this.$inertia.visit(this.$route('art.semakan.bse', this.form.art_id));
        this.$inertia.visit(this.$route('art.semakan.bse', this.form.art_id));
        // window.location.href = window.route('art.semakan.index');
       },




  },

  watch: {

  },
  mounted() {
    var today = new Date();
    this.tarikh_today = today.toISOString().split('T')[0];
    if(this.form.jantina==1)
    {
      this.title = 'Rekod Maklumat Penilaian Dayabiak'
    }
    else
    {
      this.title = 'Rekod Maklumat Penilaian Dayabiak'
    }
    this.getStatus();
    this.getPenyakitBse();
    this.getInfoPdbf();

  }

}
</script>

<style>
:root {
  --primary-color: #1976d2;
  --secondary-color: #26a69a;
  --accent-color: #9c27b0;
  --error-color: #ff5252;
  --info-color: #2196f3;
  --success-color: #4caf50;
  --warning-color: #fb8c00;
  --section-bg: #f8f9fa;
  --card-shadow: 0 3px 10px rgba(0,0,0,0.08);
}


.blue-gradient--bg {
  background: linear-gradient(135deg, var(--primary-color), #074c82) !important;
}

.form-section {
  margin-bottom: 1.5rem;
  padding: 1.5rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  border-left: 4px solid var(--primary-color);
  transition: all 0.3s ease;
}

.form-section:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e0e0e0;
}

.section-title {
  color: var(--primary-color);
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
}

.section-title i {
  margin-right: 10px;
  font-size: 1.1em;
}

.sub-section {
  margin-bottom: 1.5rem;
  padding: 1rem;
  background: var(--section-bg);
  border-radius: 6px;
}

.sub-section-header {
  display: flex;
  align-items: center;
  margin-bottom: 0.8rem;
}

/* Maklumat Ternakan - responsive & selari */
.ternakan-info {
  padding-left: 1rem; /* ~px4 */
  padding-right: 1rem;
  line-height: 28px;
}

.ternakan-info__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(200px, 1fr)); /* Tukar ke 4 kolum */
  gap: 12px 16px; /* Jarak antara baris dan kolum */
  align-items: start;
}

.ternakan-field {
  display: grid;
  grid-template-columns: 160px 20px minmax(0, 1fr);
  column-gap: 8px;
  align-items: start;
}

.ternakan-field__label {
  white-space: nowrap;
}

.ternakan-field__value {
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

@media (max-width: 1200px) {
  .ternakan-info__grid {
    grid-template-columns: repeat(2, minmax(260px, 1fr));
  }
}

@media (max-width: 768px) {
  .ternakan-info {
    padding-left: 0;
    padding-right: 0;
  }
  .ternakan-info__grid {
    grid-template-columns: 1fr;
    gap: 6px 0;
  }
}

.sub-section h4 {
  color: #455a64;
  margin: 0 0.5rem 0 0;
  font-size: 1rem;
  font-weight: 500;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-bottom: 1rem;
}

.form-field {
  flex: 1;
  min-width: 200px;
}


.blue-gradient--bg {
  background: linear-gradient(135deg, #074c82, #074c82) !important;
}

.genital-exam-container {
  padding: 1rem;
}

.exam-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.exam-item {
  padding: 1.5rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
  transition: all 0.3s ease;
}

.exam-item:hover {
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.exam-item.full-width {
  grid-column: 1 / -1;
}

.section-header.full-width {
  grid-column: 1 / -1;
}

.exam-header {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e0e0e0;
}

.exam-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 600;
  color: #2c3e50;
  display: flex;
  align-items: center;
}

.exam-icon {
  font-size: 0.7rem;
  margin-right: 10px;
  color: #1976d2;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 16px;
  max-width: 380px;
  margin: 0 auto;
  padding: 16px;
  justify-content: center;
}

.gallery-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #f8f8f8;
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.1);
}

.image-wrapper {
  width: 100%;
  height: 150px; /* Fixed height for uniformity */
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f0f0;
  border-radius: 4px;
}

.gallery-image {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensures all images fill the container uniformly */
  border-radius: 4px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

/* Uniform class for all images */
.uniform-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Uniform class for zoom modal images */
.uniform-zoom-image {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
}

.gallery-image:hover {
  transform: scale(1.05);
}

.image-actions {
  margin-top: 8px;
  display: flex;
  justify-content: center;
  gap: 8px;
}

.input-hint {
  color: black;
  font-size: 1.2rem;
  display: block;
  margin-top: 8px;
}

.info-icon {
  color: #2196f3;
  font-size: 1rem;
  margin-left: 0.5rem;
  cursor: pointer;
}

.abnormal-input {
  margin-top: 1rem;
}

/* Zoom modal styles */
.zoom-modal-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}

.full-zoom-image {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
}

.close-zoom-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .exam-grid {
    grid-template-columns: 1fr;
  }

  .image-wrapper {
    height: 120px; /* Slightly smaller on mobile */
  }
}

@media (min-width: 1200px) {
  .image-wrapper {
    height: 220px; /* Larger on big screens */
  }
}
</style>
